import { Api } from "./api"

export class WebhookApi extends Api {
  constructor() {
    super('webhooks', ['url'])
  }
}
